import React from 'react';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { CitizenParamList } from '../../../typings/Params';
import Filters from '../../../components/Filter';
import { translate } from '../../../services/translate';
import FilterInput from '../../../components/Filter/components/FilterInput';

interface Props {
    filters: CitizenParamList['CitizenBlockReasons'];
    setFilters: React.Dispatch<React.SetStateAction<CitizenParamList['CitizenBlockReasons']>>;
    textFilter: string;
    setTextFilter: React.Dispatch<React.SetStateAction<string>>;
}

export default function Filter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const navigation = useNavigation<NavigationProp<CitizenParamList, 'CitizenBlockReasons'>>();

    const handleCleanFilter = () => {
        setTextFilter('');
    };

    const handleFilter = () => {

        setFilters({
            ...filters,
            textFilter: textFilter !== '' ? textFilter : undefined,
        });

        navigation.setParams({
            ...filters,
            textFilter: textFilter !== '' ? textFilter : undefined,
        });
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />
        </Filters>
    );
}
